import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import cn from 'classnames';
import { ButtonDesktop } from '../../../../button/esm/desktop';

var styles = {"button":"calendar__button_168no","filled":"calendar__filled_168no","current":"calendar__current_168no","selected":"calendar__selected_168no"};
require('./index.css');

var SelectButton = forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, _b = _a.view, view = _b === void 0 ? 'default' : _b, restProps = __rest(_a, ["className", "children", "view"]);
    return (React.createElement(ButtonDesktop, __assign({}, restProps, { ref: ref, view: 'ghost', size: 'xs', className: cn(styles.button, styles[view], className) }), children));
});

export { SelectButton };
